import React from 'react';
import {
    HashRouter as Router
} from "react-router-dom";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WarehouseIcon from '@mui/icons-material/Warehouse';
// Additional Icon can be found at
// https://mui.com/material-ui/material-icons/

import BaseLayout from "../layout/BaseLayout"
const API_URL = process.env.REACT_APP_API_URL;
const SERVER_NAME = process.env.REACT_APP_SERVERNAME

export default function MainPage() {
    console.log("process.env.SERVERNAME=", process.env.REACT_APP_SERVERNAME)
    return (
        <div>
            <Router>
                <BaseLayout drawer_items={[
                    {
                        text: '注册/登陆', href: `${API_URL}/user/sign-in?next=${SERVER_NAME}`,
                        component: "a", icon: <PersonAddIcon />
                    },
                    { text: '财务', url: '/finance', icon: <MonetizationOnIcon /> },
                    { text: '线路管理', url: '/warehouse', icon: <WarehouseIcon /> },
                    { text: '系统配置', url: '/system', icon: <WarehouseIcon /> },
                    // {text: '收货地址', url: '/address', icon:<BusinessIcon/>},
                    // {text: '添加包裹', url: '/parcel/add', icon:<LocalMallIcon/>},
                    // {text: '包裹', url: '/parcel', icon:<LocalMallIcon/>},
                    // {text: '订单', url: '/order', icon:<ShoppingCartIcon/>},
                ]} />
            </Router>
            {/* <img width={500} src={logo} alt="Logo" />
            <LoginDialog/>
            <RegisterDialog/> */}
        </div>
    )
}